import React,{useState,useEffect} from 'react';
import { withRouter } from "react-router-dom";
import { makeStyles, useTheme } from '@material-ui/core/styles';
import Mastercontent from '../../components/Mastercontent/Mastercontent';
import { API_URL, GRAPHQL_DEV_CLIENT } from '../../config';
import { MASTEREVENTS} from '../../graphql/query';
import data from "./data.json"
import Page from '../../components/Page'
import { NetworkContext } from '../../context/NetworkContext';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';

const useStyles = makeStyles(theme => ({
  root: {
  //  padding: theme.spacing(3)
  },
  results: {
    marginTop: theme.spacing(3)
  }
}));

export const Dummyscreen = withRouter(props => {
  const [isadd, setIsadd] = React.useState(false)
  const [searchtext, setSearchtext] = useState("");
  const { sendNetworkRequest } = React.useContext(NetworkContext);
  const [mastervalue, setMastervalue] = React.useState([])

  const classes = useStyles();

  const [filtervalue, setFiltervalue] = React.useState([])

  async function createtax(taxcontent)
  {

    let response =  await sendNetworkRequest('/managegemshapes', {}, taxcontent)
     getmaster()
  }
  async function getmaster()
  {
    const url = GRAPHQL_DEV_CLIENT;
    const opts = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ query: MASTEREVENTS  })
    };
    // console.log("helo",setProductCtx)
    fetch(url, opts)
      .then(res => res.json())
      .then(fatchvalue => {
        setMastervalue(fatchvalue.data.allMasterevents.nodes)
        setFiltervalue(fatchvalue.data.allMasterevents.nodes)
      })
      .catch(console.error)
  }
  useEffect(() => {
    getmaster()
  }, [])
  function applysearch(searchcontent)
  {
    setSearchtext(searchcontent)
  }
  function addcategory()
  {
    setIsadd(true)
  }
  function cancelcreation()
  {
    setIsadd(false)
  }
  useEffect(() => {
   
  }, [])
  async function search(taxcontent)
  {
    const filteredHomes = mastervalue.filter( x => 
      x.name.toLowerCase() ? x.name.toLowerCase().match(taxcontent+ ".*") : null 
    );
    setFiltervalue(filteredHomes)
  }
  return (
    <>
    <Page
    className={classes.root}
    title="Orders Management List"
  >

<TableContainer component={Paper}>
      <Table className={classes.table} aria-label="simple table">
        <TableHead>
        {data.rows.map((row, index) => (
           <TableRow>
              {row.columns.map((col, index) => (
                      <TableCell align="center" rowSpan={col.rowspan} colSpan={col.colspan}>{col.label}</TableCell>
                 ))}
           </TableRow>
        ))}
          {/* <TableRow>
            <TableCell rowSpan={2}>SI No</TableCell>
            <TableCell rowSpan={2}>District name</TableCell>
            <TableCell align="center" colSpan={3}>So Far</TableCell>
            <TableCell align="center" colSpan={4}>Carbs&nbsp;(g)</TableCell>
          </TableRow>
          <TableRow>
            <TableCell align="center">Sample Tested</TableCell>
            <TableCell align="center">Positive</TableCell>
            <TableCell align="center">Negative</TableCell>
            <TableCell align="center">Tested</TableCell>
            <TableCell align="center">Received</TableCell>
            <TableCell align="center">Positive</TableCell>
            <TableCell align="center">Negative</TableCell>
            <TableCell align="center">Awaited</TableCell>
          </TableRow> */}
        </TableHead>
        <TableBody>
          
        </TableBody>
      </Table>
    </TableContainer>

        {/* <Mastercontent 
        title= {"Master Events"} 
        button_title="Add New" 
        onCreate={createtax} 
        onSearch={search} 
        columns={data.columns} 
        values={filtervalue}/> */}

    </Page>
    </>
  )
});

export default Dummyscreen;